import React, { useEffect, useState, forwardRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

import clsx from "clsx";
import {
  Button,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import Switch from "react-switch";

import iconLeftArrow from "../../../assets/images/icon-left-arrow.png";
import iconChat from "../../../assets/images/chat-icon.png";
import Chat from "../../../assets/images/chat.png";
import iconArrowDown from "../../../assets/images/arrow-down.png";

import CritereImpactantHover from "../../../assets/images/critere-impactant-hover.png";
import CritereImpactantSelected from "../../../assets/images/critere-impactant-selected.png";
import CritereImpactantNonSelected from "../../../assets/images/critere-impactant-non-selected.png";

import CanalSelected from "../../../assets/images/canal-selected.png";
import Norme from "../../../assets/images/norme.png";
import NormeSelected from "../../../assets/images/norme-selected.png";
import Motif from "../../../assets/images/motif.png";
import MotifSelected from "../../../assets/images/motif-selected.png";
import Autre from "../../../assets/images/autre.png";
import AutreSelected from "../../../assets/images/autre-selected.png";
import Plus from "../../../assets/images/plus-cercle.png";
import PointsDragDrop from "../../../assets/images/points-drag-drop.png";
import ArrowDown from "../../../assets/images/arrow-down-.png";
import ArrowUpSelected from "../../../assets/images/arrow-up-selected.png";
import PenSelected from "../../../assets/images/selected-pen.png";
import CheckCerclePrimary from "../../../assets/images/check-circle-primary.png";
import Trash from "../../../assets/images/trash.png";
import XRemove from "../../../assets/images/x-remove.svg";

import iconMalusRed from "../../../assets/images/icon-malus-red.png";
import iconMalus from "../../../assets/images/icon-malus.png";

import iconBonusGreen from "../../../assets/images/icon-bonus-green.png";
import iconBonus from "../../../assets/images/icon-bonus.png";

import iconAddBonusMalus from "../../../assets/images/add-bonus-malus-icon.png";
import iconAddBonusMalusColor from "../../../assets/images/add-bonus-malus-icon-color.png";

import iconMoinScore from "../../../assets/images/moin-score.png";
import iconPlusScore from "../../../assets/images/plus-score.png";

import ping from "../../../assets/images/ping.png";
import pingSelected from "../../../assets/images/ping-selected.png";
import pingHover from "../../../assets/images/ping-hover.png";
import paintBrush from "../../../assets/images/paint-brush.png";
import blockedBrush from "../../../assets/images/blocked.png";
import checkCircleWhite from "../../../assets/images/check-circle-white.png";

import "../AddGrille/addGrille.css";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";

const staticGrilles = [
  {
    id: "relationnel",
    name: "Relationnel",
  },
  {
    id: "savoir",
    name: "Savoir etre",
  },
];

const paletteDeCouleur = [
  "#FCE5E5",
  "#E30707",
  "#FEA729",
  "#FFD800",
  "#E7F6E7",
  "#1CA91B",
];
const valeursAttributes = [
  {
    id: 1,
    name: "Valeur 1",
    color: "rgb(28, 169, 27)",
    backGroundColor: "rgba(28, 169, 27, 0.1)",
  },
  {
    id: 2,
    name: "Valeur 2",
    color: "rgba(227, 7, 7)",
    backGroundColor: "rgba(227, 7, 7, 0.1)",
  },
];

const Critere = (props) => {
  const history = useHistory();

  const [clickedAttributes, setClickedAttributes] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedGrille, setSelectedGrille] = useState("");
  const [selectedCritereImpact, setSelectedCritereImpact] = useState(false);
  const [hoveredCritereImpact, setHovredCritereImpact] = useState(false);
  const [valeursAtt, setValeursAtt] = useState([]);
  const [isSelectionNeutre, setIsSelectionNeutre] = useState(true);
  const [isSelectionBonus, setIsSelectionBonus] = useState(false);
  const [isSelectionselectedBonus, setIsSelectionselectedBonus] = useState({});
  const [selectedcountbonus, setSelectedcountbonus] = useState({});
  const [isSelectionMalus, setIsSelectionMalus] = useState(false);
  const [isSelectionselectedMalus, setIsSelectionselectedMalus] = useState({});

  const [addedDetailsBonus, setAddedDetailsBonus] = useState(false);
  const { datagrilles, datagrille } = useSelector((state) => state.grille);

  const [tab, setIsClick] = useState([1]);
  const [openCritere, setOpenCritere] = useState(false);
  const [openCritere1, setOpenCritere1] = useState(false);

  const [isOpenComment, setIsOpenComment] = useState(false);

  const [groupeCritereName, setGroupeCritereName] = useState("Relationnel");
  const [score, setScore] = useState(10);
  const [selectedPing, setSelectedPing] = useState(false);
  const [hoverPing, setHoverPing] = useState(false);
  const [hoverPalette, setHoverPalette] = useState(false);

  const [colorCriteriaValue, setColorCriteriaValue] = useState("#5800E2");

  // const [score, setScore] = useState(10);
  // const [selectedPing, setSelectedPing] = useState({});
  // const [hoverPing, setHoverPing] = useState(false);
  const [selectedScore, setSelectedcore] = useState({ 0: false });
  const [selecteaddscore, setSelecteaddscore] = useState({});
  const [valuscire, setValuescore] = useState([]);
  const [count, setCount] = useState(0);
  const [countbonus, setCountbuns] = useState(0);
  const [countmalus, setCountmalus] = useState(0);

  const [countsbonus, setCountsbonus] = useState(0);
  const [countsmalus, setCountsmalus] = useState(0);

  const location = useLocation();
  const dup = location?.state?.dup;
  var bonus =
    props.data.CriteriaGroup[props.id1]?.Criteria[props.id]?.CriteriaOption
      .length;

  useEffect(() => {
    if (dup) {
      setValeursAtt(
        datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]?.CriteriaValue
      );

      if (
        props?.data?.CriteriaGroup[props.id1]?.Criteria[
          props.id
        ]?.CriteriaOption.filter((e) => e.name === "Bonus").length > 0
      ) {
        setIsSelectionBonus(true);
      }
      if (
        props?.data?.CriteriaGroup[props.id1]?.Criteria[
          props.id
        ]?.CriteriaOption.filter((e) => e.name === "Malus").length > 0
      ) {
        setIsSelectionMalus(true);
      }
    }
  }, [datagrille]);
  const addClick = () => {
    let staticValue = {
      name: "",
      description: "",
      color: "none",
    };

    if (valeursAtt.length < 5) {
      setOpenCritere1(!openCritere1);
      setOpenCritere(false);
      setValeursAtt([
        ...valeursAtt,
        props.data.CriteriaGroup[props.id1].Criteria[props.id].CriteriaValue,
      ]);
      props.data.CriteriaGroup[props.id1].Criteria[props.id].CriteriaValue.push(
        staticValue
      );
      setCount(count + 1);
    }
  };

  const removeClick = (i) => {
    setValeursAtt(valeursAtt.filter(({ id }) => id !== i));
  };

  const tooltipPalette = () => {
    setHoverPalette(!hoverPalette);
  };

  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className="textarea-comment"
        as="textarea"
        rows={3}
        defaultValue={
          dup
            ? datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]
                ?.description
            : ""
        }
        onKeyUp={(e) =>
          props.handelchangeDescriptionCritere(e, props.id1, props.id)
        }
      />
      <div className="buttons-of-textarea-comment">
        <span style={{ color: "#B7B7B7", cursor: "pointer" }}>Annuler</span>
        <span style={{ color: "#5800e2", cursor: "pointer" }}>Ajouter</span>
      </div>
    </Tooltip>
  );

  return (
    <div
      className={clsx(
        { "critere-bar": true },
        { height: openCritere || openCritere1 }
      )}
    >
      <div className="container-drag-drop-critere">
        <img src={PointsDragDrop} />
      </div>
      <div style={{ height: "100%", width: "100%" }}>
        <div className="first-row-under-critere">
          <div className="container-bar-critere-section-1">
            <div style={{ marginLeft: 10, marginRight: -35 }}>
              <input
                className={clsx(
                  { "container-input": true },
                  {
                    "container-input-disabled":
                      !(
                        props.selectedcritere[props.id] &&
                        props.selectedgroupecritere[props.id1]
                      ) && !props.hasError("namecritria"),
                  },
                  {
                    "container-input-invalid-disabled":
                      !(
                        props.selectedcritere[props.id] &&
                        props.selectedgroupecritere[props.id1]
                      ) && props.hasError("namecritria"),
                  },
                  {
                    "container-input-invalid":
                      props.selectedcritere[props.id] &&
                      props.selectedgroupecritere[props.id1] &&
                      props.hasError("namecritria"),
                  }
                )}
                placeholder={
                  dup
                    ? datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]
                        ?.name
                    : "nom de critere"
                }
                type="text"
                defaultValue={
                  dup
                    ? datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]
                        ?.name
                    : ""
                }
                onKeyDown={(e) =>
                  props.handelChangeNamecritere(e, props.id, props.id1)
                }
                onClick={() => {
                  setOpenCritere(!openCritere);
                  setOpenCritere1(false);
                }}
                disabled={
                  !(
                    props.selectedcritere[props.id] &&
                    props.selectedgroupecritere[props.id1]
                  )
                }
              />
              <div
                className={clsx(
                  { "btn-inside": true },
                  {
                    "container-icons-groupe-critere":
                      props.selectedcritere[props.id] &&
                      props.selectedgroupecritere[props.id1],
                  },
                  {
                    "container-icons-groupe-critere-selected": !(
                      props.selectedcritere[props.id] &&
                      props.selectedgroupecritere[props.id1]
                    ),
                  }
                )}
                key={props.id}
                onClick={() => {
                  setOpenCritere(false);

                  props.handelEditName(props.id, props.id1);
                }}
              >
                {props.selectedcritere[props.id] &&
                props.selectedgroupecritere[props.id1] ? (
                  <img src={CheckCerclePrimary} height={15} />
                ) : (
                  <img src={PenSelected} height={15} />
                )}
              </div>
            </div>
            <div>
              {!hoveredCritereImpact && !selectedCritereImpact ? (
                <OverlayTrigger
                  key="bottom"
                  placement="bottom"
                  style={{}}
                  overlay={
                    <Tooltip
                      data-color="#5800e2"
                      className="critere"
                      id={`tooltip-bottom`}
                    >
                      Critere impactant
                    </Tooltip>
                  }
                >
                  <img
                    src={CritereImpactantHover}
                    height={40}
                    onClick={() => {
                      setSelectedCritereImpact(!selectedCritereImpact);
                    }}
                  />
                </OverlayTrigger>
              ) : (
                <div>
                  {selectedCritereImpact ? (
                    <img
                      src={CritereImpactantSelected}
                      height={40}
                      onClick={() => {
                        setSelectedCritereImpact(!selectedCritereImpact);
                      }}
                    />
                  ) : (
                    <img
                      src={CritereImpactantNonSelected}
                      className="logo-resp"
                      height={30}
                    />
                  )}
                </div>
              )}
            </div>

            <OverlayTrigger
              key="bottom"
              placement="bottom"
              style={{}}
              overlay={
                <Tooltip
                  data-color="#5800e2"
                  className="critere"
                  id={`tooltip-bottom`}
                >
                  Coefficient
                </Tooltip>
              }
            >
              <Form.Control
                style={{
                  border: "dashed 1px",
                  borderColor: "#CCB2F5 !important",
                  backgroundColor: "rgba(183, 183, 183, 0.1)",
                  width: "12%",
                  padding: "5px",
                  top: 0,
                }}
                placeholder="1"
                min="1"
                max="10"
                type="number"
                tabIndex="0"
              />
            </OverlayTrigger>
            {valeursAtt.map((key, index) => (
              <div
                key={index}
                style={{ marginBottom: 5, marginRight: "-100px" }}
              >
                <Form.Control
                  data-color={
                    props.data.CriteriaGroup[props.id1].Criteria[props.id]
                      .CriteriaValue[index]?.color
                  }
                  className="container-input-values borderColor"
                  style={{
                    color: key.color || "rgb(183, 183, 183)",
                    backgroundColor:
                      `${
                        props.data.CriteriaGroup[props.id1].Criteria[props.id]
                          .CriteriaValue[index]?.color
                      }20` || "rgba(183, 183, 183, 0.1)",
                    top: valeursAtt.length > 4 ? 15 : 3,
                  }}
                  type="text"
                  key={key.id}
                  placeholder={
                    dup
                      ? datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]
                          ?.CriteriaValue[index]?.name
                      : "value"
                  }
                  defaultValue={
                    dup
                      ? datagrille?.CriteriaGroup[props.id1]?.Criteria[props.id]
                          ?.CriteriaValue[index]?.name
                      : ""
                  }
                  tabIndex="0"
                  onChange={(e) => {
                    props.handelChangeValue(e, props.id, props.id1, index);
                    setCount(index);
                  }}
                  onClick={() => {
                    setOpenCritere1(!openCritere1);
                    setOpenCritere(false);
                    setCountbuns(0);
                    setCountmalus(0);
                    setCount(index);
                    setHoverPalette(false);
                    setColorCriteriaValue(
                      props?.data.CriteriaGroup[props.id1]?.Criteria[props.id]
                        ?.CriteriaValue[index]?.color
                    );
                  }}
                />
                <div className="btn-inside-remove">
                  {valeursAtt.length > 4 ? (
                    <img
                      className="parent"
                      src={XRemove}
                      height={22}
                      onClick={() => removeClick(index)}
                    />
                  ) : null}
                </div>
              </div>
            ))}
            <div
              className="add-container"
              onClick={() => {
                addClick();
              }}
              style={{ zIndex: 10 }}
            >
              <img src={iconAddBonusMalusColor} />
            </div>
          </div>
          <div className="container-bar-critere-section-2">
            <div className="container-icons-critere">
              {props.isOpenComment1 ? (
                <div className="container-icons-groupe-critere">
                  <img
                    className="img-chat-position-groupe-critere"
                    width={15}
                    src={Chat}
                    onClick={() => {
                      props.handelClosecommentCritere(false);
                    }}
                  />
                </div>
              ) : (
                <div className="container-icons-groupe-critere">
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement="bottom-end"
                    overlay={popover}
                  >
                    <img
                      className="img-chat-position-add-grille"
                      width={15}
                      src={Chat}
                      onClick={() => {
                        props.handelClosecommentCritere(false);
                      }}
                    />
                  </OverlayTrigger>
                </div>
              )}
            </div>

            <div className="container-icons-critere">
              <img
                width={15}
                src={Trash}
                onClick={() => props.handelDeleteCriters(props.id, props.id1)}
              />
            </div>

            <div
              className={clsx(
                { "container-icons-critere": openCritere },
                { "container-icons-groupe-critere-selected": !openCritere }
              )}
              onClick={() => {
                setOpenCritere(false);
              }}
            >
              {openCritere || dup ? (
                <img src={ArrowUpSelected} />
              ) : (
                <img src={ArrowDown} />
              )}
            </div>
          </div>
        </div>

        {openCritere && (
          <div className="second-row-under-critere">
            <div
              className="section-bonus-malus"
              style={{
                height:
                  isSelectionBonus || isSelectionMalus ? "fit-content" : "10vh",
                width:
                  props.data.CriteriaGroup[props.id1]?.Criteria[props.id]
                    ?.CriteriaOption[bonus - 1]?.CriteriaOptionValue.length >
                    2 && "fit-content",
              }}
            >
              <div className="d-flex  ">
                <div
                  className="bonus-malus-container d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setIsSelectionNeutre(!isSelectionNeutre);

                    setIsSelectionBonus(false);
                    setIsSelectionMalus(false);
                    props.data.CriteriaGroup[props.id1].Criteria[
                      props.id
                    ].CriteriaOption = [];
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                  >
                    <g id="noun-blocked-1745761" transform="translate(-98 -28)">
                      <path
                        style={{
                          fill: isSelectionNeutre ? "#5800E2" : "#B7B7B7",
                        }}
                        id="Tracé_14878"
                        data-name="Tracé 14878"
                        d="M110.5,28A12.506,12.506,0,0,0,99.71,46.819a.837.837,0,1,0,1.441-.851,10.83,10.83,0,0,1,14.818-14.818.837.837,0,1,0,.851-1.441A12.472,12.472,0,0,0,110.5,28Zm8.134,3.5a.834.834,0,0,0-.573.252L101.75,48.069a.835.835,0,1,0,1.18,1.18L119.242,32.93a.833.833,0,0,0-.608-1.432Zm1.892,2.266a.833.833,0,0,0-.677,1.267,10.83,10.83,0,0,1-14.818,14.818.837.837,0,1,0-.851,1.441A12.507,12.507,0,0,0,121.29,34.181a.833.833,0,0,0-.764-.417Z"
                        transform="translate(0 0)"
                        fill="#b7b7b7"
                      />
                    </g>
                  </svg>
                  <button
                    style={{
                      fontFamily: "Gilroy",
                      fontSize: 16,
                      color: isSelectionNeutre ? "#5800E2" : "#B7B7B7",
                      border: "0px",
                      backgroundColor: "#FAFAFA",
                    }}
                    value={"Neutre"}
                  >
                    Neutre
                  </button>
                </div>

                <button
                  className="bonus-malus-container d-flex align-items-center justify-content-center"
                  style={{
                    border: "none",
                    fontFamily: "Gilroy",
                    fontSize: 16,
                    color: isSelectionBonus ? "rgb(28, 169, 27)" : "#B7B7B7",
                    border: 0,
                    backgroundColor: isSelectionBonus
                      ? "rgba(28, 169, 27, 0.1)"
                      : "#FAFAFA",
                  }}
                  onClick={() => {
                    if (isSelectionNeutre) {
                      setIsSelectionNeutre(false);
                    }
                    setIsSelectionBonus(!isSelectionBonus);
                    // isSelectionselectedBonus[count]=!isSelectionBonus
                    // setIsSelectionselectedBonus({...isSelectionselectedBonus})
                    setCountbuns(countbonus + 1);
                    selectedcountbonus[count] = isSelectionBonus;
                    setSelectedcountbonus({ ...selectedcountbonus });
                    setSelectedcore({});
                    isSelectionBonus && bonus === 2 ? (bonus = 1) : (bonus = 2);

                    if (isSelectionMalus) {
                      setCountsbonus(1);
                      setCountsmalus(0);
                    } else {
                      setCountsbonus(1);
                    }
                    props.handelChangeBonus(
                      "Bonus",
                      props.id,
                      props.id1,
                      count,
                      countbonus,
                      count
                    );
                  }}
                >
                  <img src={isSelectionBonus ? iconBonusGreen : iconBonus} />
                  Bonus
                </button>

                <button
                  className="bonus-malus-container d-flex align-items-center justify-content-center"
                  style={{
                    border: "none",
                    fontFamily: "Gilroy",
                    fontSize: 16,
                    color: isSelectionMalus ? "#E30707" : "#B7B7B7",
                    border: "0px",
                    backgroundColor: isSelectionMalus ? "#FCE5E5" : "#FAFAFA",
                  }}
                  onClick={() => {
                    if (isSelectionNeutre) {
                      setIsSelectionNeutre(false);
                    }
                    setIsSelectionMalus(!isSelectionMalus);

                    setCountmalus(countmalus + 1);

                    isSelectionMalus && bonus === 1 ? (bonus = 2) : (bonus = 1);

                    if (isSelectionBonus) {
                      setCountsmalus(1);
                      setCountsbonus(0);
                    } else {
                      setCountmalus(1);
                    }
                    props.handelChangeBonus(
                      "Malus",
                      props.id,
                      props.id1,
                      count,
                      countmalus,
                      count
                    );
                  }}
                >
                  <img
                    src={isSelectionMalus ? iconMalusRed : iconMalus}
                    value="Malus"
                  />
                  Malus
                </button>
              </div>
              {(isSelectionBonus && countsbonus === 1) ||
              (isSelectionBonus && countsbonus === 0 && !isSelectionMalus) ? (
                <div>
                  <hr />
                  <div
                    className={clsx(
                      { "d-sm-flex": true },
                      { "align-items-baseline ": !addedDetailsBonus },
                      { "align-items-center": addedDetailsBonus }
                    )}
                    style={{ gap: "15px" }}
                  >
                    {props.data.CriteriaGroup[props.id1]?.Criteria[
                      props.id
                    ]?.CriteriaOption.filter((e) => e.name === "Bonus")[0]
                      ?.CriteriaOptionValue &&
                      props.data.CriteriaGroup[props.id1]?.Criteria[
                        props.id
                      ]?.CriteriaOption.filter(
                        (e) => e.name === "Bonus"
                      )[0]?.CriteriaOptionValue.map((e, i) => (
                        <div
                          key={i}
                          className={"container-bonus-malus  "}
                          style={{
                            height:
                              selectedScore[i] || addedDetailsBonus
                                ? "fit-content"
                                : "40px",
                            width: "fit-content",
                          }}
                        >
                          <div
                            key={i}
                            className="d-flex"
                            style={{
                              gap: "10px",
                            }}
                            onClick={() => {
                              selectedScore[i] = !addedDetailsBonus;
                              setSelectedcore({ ...selectedScore });
                              setAddedDetailsBonus(selectedScore[i]);
                            }}
                          >
                            <Form.Control
                              type="textarea"
                              onChange={(e) =>
                                props.handelChangeNameBonnus(
                                  e,
                                  props.id,
                                  props.id1,
                                  count,
                                  i,
                                  bonus
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  selectedScore[i] = false;
                                  setSelectedcore({ ...selectedScore });
                                }
                              }}
                              placeholder={e.name}
                              style={{
                                height: "80%",
                                border: 0,
                                width: e.name.length < 4 ? "40px" : "100px",
                              }}
                            />

                            <svg
                              style={{
                                transform: selectedScore[i]
                                  ? "rotate(45deg)"
                                  : null,
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.5"
                              height="20.5"
                              viewBox="0 0 20.5 20.5"
                              onClick={() => {
                                if (selectedScore[i]) {
                                  if (i > -1) {
                                    props.data.CriteriaGroup[
                                      props.id1
                                    ]?.Criteria[
                                      props.id
                                    ]?.CriteriaOption[0]?.CriteriaOptionValue.splice(
                                      i,
                                      1
                                    ); // 2nd parameter means remove one item only
                                  }
                                }
                              }}
                            >
                              <path
                                style={{
                                  fill: selectedScore[i]
                                    ? "#5800E2"
                                    : "#B7B7B7",
                                }}
                                id="Tracé_14875"
                                data-name="Tracé 14875"
                                d="M12,7a1,1,0,0,0-1,1v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2H13V8A1,1,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
                                transform="translate(-1.75 -1.75)"
                                fill="#b7b7b7"
                                stroke="#fff"
                                strokeWidth="0.5"
                              />
                            </svg>
                          </div>

                          {selectedScore[i] ? (
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: 10 }}
                            >
                              <div className="score-bonus-malus-edit">
                                <img
                                  src={iconMoinScore}
                                  onClick={() => {
                                    selecteaddscore[i] = score;
                                    setSelecteaddscore({ ...selecteaddscore });
                                    props.handelChangeScore(
                                      score,
                                      props.id,
                                      props.id1,
                                      count,
                                      i,
                                      bonus
                                    );
                                    setScore(score - 10);
                                  }}
                                />
                                <div>{score === undefined ? 0 : e.score}</div>
                                <img
                                  src={iconPlusScore}
                                  onClick={() => {
                                    setSelecteaddscore({ ...selecteaddscore });
                                    props.handelChangeScore(
                                      score,
                                      props.id,
                                      props.id1,
                                      count,
                                      i,
                                      bonus
                                    );
                                    setScore(score + 10);
                                  }}
                                />
                              </div>

                              <div
                                style={{ cursor: "pointer" }}
                                onMouseEnter={() => setHoverPing(true)}
                                onMouseLeave={() => setHoverPing(false)}
                              >
                                {hoverPing && !selectedPing[i] ? (
                                  <OverlayTrigger
                                    key="bottom"
                                    placement="bottom"
                                    overlay={
                                      <Tooltip
                                        data-color="#5800e2"
                                        className="critere"
                                        id={`tooltip-bottom`}
                                      >
                                        Appliquer par tous
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src={pingHover}
                                      height={30}
                                      onClick={() => {
                                        selectedPing[i] = true;
                                        setSelectedPing({ ...selectedPing });
                                      }}
                                    />
                                  </OverlayTrigger>
                                ) : (
                                  <div>
                                    {selectedPing[i] ? (
                                      <img
                                        src={pingSelected}
                                        className="logo-resp"
                                        height={30}
                                        onClick={() => {
                                          selectedPing[i] = false;
                                          setSelectedPing({ ...selectedPing });
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={ping}
                                        className="logo-resp"
                                        height={30}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))}

                    {/* ########################## */}

                    <div
                      className="add-container"
                      onClick={() => {
                        setScore(0);

                        props.data.CriteriaGroup[props.id1]?.Criteria[
                          props.id
                        ]?.CriteriaOption.filter(
                          (e) => e.name === "Bonus"
                        )[0]?.CriteriaOptionValue.push({
                          name: "",
                          score: 0,
                        });
                        selectedScore[
                          props.data.CriteriaGroup[props.id1].Criteria[
                            props.id
                          ].CriteriaOption.filter((e) => e.name === "Bonus")[0]
                            ?.CriteriaOptionValue.length - 1
                        ] = false;

                        setSelectedcore({ ...selectedScore });
                      }}
                    >
                      <img src={iconAddBonusMalusColor} />
                    </div>
                  </div>
                </div>
              ) : (isSelectionMalus && countsmalus === 1) ||
                (!isSelectionBonus && countsmalus === 0 && isSelectionMalus) ? (
                <div>
                  <hr />
                  <div
                    className={clsx(
                      { "d-sm-flex": true },
                      { "align-items-baseline ": !addedDetailsBonus },
                      { "align-items-center": addedDetailsBonus }
                    )}
                    style={{ gap: "15px" }}
                  >
                    {props.data.CriteriaGroup[props.id1]?.Criteria[
                      props.id
                    ]?.CriteriaOption.filter((e) => e.name === "Malus")[0]
                      ?.CriteriaOptionValue &&
                      props.data.CriteriaGroup[props.id1]?.Criteria[
                        props.id
                      ]?.CriteriaOption.filter(
                        (e) => e.name === "Malus"
                      )[0]?.CriteriaOptionValue.map((e, i) => (
                        <div
                          key={i}
                          className={"container-bonus-malus  "}
                          style={{
                            height:
                              selectedScore[i] || addedDetailsBonus
                                ? "fit-content"
                                : "40px",
                            width: "fit-content",
                          }}
                        >
                          <div
                            key={i}
                            className="d-flex"
                            style={{
                              gap: "10px",
                            }}
                            onClick={() => {
                              selectedScore[i] = !addedDetailsBonus;
                              setSelectedcore({ ...selectedScore });
                              setAddedDetailsBonus(selectedScore[i]);
                            }}
                          >
                            <Form.Control
                              type="textarea"
                              onChange={(e) =>
                                props.handelChangeNameBonnus(
                                  e,
                                  props.id,
                                  props.id1,
                                  count,
                                  i,
                                  bonus
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  selectedScore[i] = false;
                                  setSelectedcore({ ...selectedScore });
                                }
                              }}
                              placeholder={e.name}
                              style={{
                                height: "80%",
                                border: 0,
                                width: e.name.length < 4 ? "40px" : "100px",
                              }}
                            />

                            <svg
                              style={{
                                transform: selectedScore[i]
                                  ? "rotate(45deg)"
                                  : null,
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.5"
                              height="20.5"
                              viewBox="0 0 20.5 20.5"
                              onClick={() => {
                                if (selectedScore[i]) {
                                  if (i > -1) {
                                    props.data.CriteriaGroup[
                                      props.id1
                                    ]?.Criteria[
                                      props.id
                                    ]?.CriteriaOption[1]?.CriteriaOptionValue.splice(
                                      i,
                                      1
                                    ); // 2nd parameter means remove one item only
                                  }
                                }
                              }}
                            >
                              <path
                                style={{
                                  fill: selectedScore[i]
                                    ? "#5800E2"
                                    : "#B7B7B7",
                                }}
                                id="Tracé_14875"
                                data-name="Tracé 14875"
                                d="M12,7a1,1,0,0,0-1,1v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2H13V8A1,1,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
                                transform="translate(-1.75 -1.75)"
                                fill="#b7b7b7"
                                stroke="#fff"
                                strokeWidth="0.5"
                              />
                            </svg>
                          </div>

                          {selectedScore[i] ? (
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: 10 }}
                            >
                              <div className="score-bonus-malus-edit">
                                <img
                                  src={iconMoinScore}
                                  onClick={() => {
                                    selecteaddscore[i] = score;
                                    setSelecteaddscore({ ...selecteaddscore });
                                    props.handelChangeScore(
                                      score,
                                      props.id,
                                      props.id1,
                                      count,
                                      i,
                                      bonus
                                    );
                                    setScore(score - 10);
                                  }}
                                />
                                <div>{score === undefined ? 0 : e.score}</div>
                                <img
                                  src={iconPlusScore}
                                  onClick={() => {
                                    setSelecteaddscore({ ...selecteaddscore });
                                    props.handelChangeScore(
                                      score,
                                      props.id,
                                      props.id1,
                                      count,
                                      i,
                                      bonus
                                    );
                                    setScore(score + 10);
                                  }}
                                />
                              </div>

                              <div
                                style={{ cursor: "pointer" }}
                                onMouseEnter={() => setHoverPing(true)}
                                onMouseLeave={() => setHoverPing(false)}
                              >
                                {hoverPing && !selectedPing[i] ? (
                                  <OverlayTrigger
                                    key="bottom"
                                    placement="bottom"
                                    overlay={
                                      <Tooltip
                                        data-color="#5800e2"
                                        className="critere"
                                        id={`tooltip-bottom`}
                                      >
                                        Appliquer par tous
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src={pingHover}
                                      height={30}
                                      onClick={() => {
                                        selectedPing[i] = true;
                                        setSelectedPing({ ...selectedPing });
                                      }}
                                    />
                                  </OverlayTrigger>
                                ) : (
                                  <div>
                                    {selectedPing[i] ? (
                                      <img
                                        src={pingSelected}
                                        className="logo-resp"
                                        height={30}
                                        onClick={() => {
                                          selectedPing[i] = false;
                                          setSelectedPing({ ...selectedPing });
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={ping}
                                        className="logo-resp"
                                        height={30}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))}

                    {/* ########################## */}

                    <div
                      className="add-container"
                      onClick={() => {
                        setScore(0);

                        props.data.CriteriaGroup[props.id1]?.Criteria[
                          props.id
                        ]?.CriteriaOption.filter(
                          (e) => e.name === "Malus"
                        )[0]?.CriteriaOptionValue.push({
                          name: "",
                          score: 0,
                        });
                        selectedScore[
                          props.data.CriteriaGroup[props.id1].Criteria[
                            props.id
                          ].CriteriaOption.filter((e) => e.name === "Malus")[0]
                            ?.CriteriaOptionValue.length - 1
                        ] = false;

                        setSelectedcore({ ...selectedScore });
                      }}
                    >
                      <img src={iconAddBonusMalusColor} />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        )}
        {openCritere1 && (
          <div className="second-row-under-critere">
            <textarea
              className="section-description"
              style={{
                height: "10vh",
                //  padding:"20px",
                borderColor: colorCriteriaValue,
              }}
              placeholder={
                dup
                  ? datagrille.CriteriaGroup[props.id1]?.Criteria[props.id]
                      ?.CriteriaValue[count]?.description
                  : props.data.CriteriaGroup[props.id1]?.Criteria[props.id]
                      ?.CriteriaValue[count]?.description
              }
              defaultValue={
                dup
                  ? datagrille.CriteriaGroup[props.id1]?.Criteria[props.id]
                      ?.CriteriaValue[count]?.description
                  : ""
              }
              onKeyUp={(e) =>
                props.handelChangeValuedescription(
                  e,
                  props.id,
                  props.id1,
                  count,
                  colorCriteriaValue
                )
              }
            />
            <div
              className="button-palette-couleur d-flex justify-content-center align-items-center"
              onClick={tooltipPalette}
            >
              <img src={paintBrush} />
            </div>
            <div
              className={clsx(
                { "d-none": !hoverPalette },
                { "d-block": hoverPalette }
              )}
            >
              <Tooltip
                id="tooltip-palette-couleur"
                className="d-flex justify-content-center"
              >
                <div
                  className="color-cercle d-flex justify-content-center align-items-center"
                  style={{ backgroundColor: "#E0E0E0" }}
                  onClick={() => {
                    setColorCriteriaValue("#5800E2");
                    props.handelChangeValueColor(
                      props.id,
                      props.id1,
                      count,
                      "#5800E2"
                    );
                  }}
                >
                  <img width={18} src={blockedBrush} />
                </div>
                {paletteDeCouleur.map((color) => (
                  <div
                    className="color-cercle d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: color }}
                    onClick={() => {
                      setColorCriteriaValue(color);
                      props.handelChangeValueColor(
                        props.id,
                        props.id1,
                        count,
                        color
                      );
                    }}
                  >
                    {color === colorCriteriaValue ? (
                      <img width={18} src={checkCircleWhite} />
                    ) : null}
                  </div>
                ))}
              </Tooltip>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Critere;
